import angular from 'angular';

export const MeurhOrganogramaRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider) {
        $stateProvider
            .state('meurh_organograma', {
                url: '/organograma',
                template: require('html-loader!./index/organograma.html'),
                controller: 'MeurhOrganogramaIndexController',
                controllerAs: 'mrh_rgngrm_ndx_cntrllr',
                reloadOnSearch: false,
            });
    }
];
